import { useContext, useEffect, useRef, useState } from "react"
import { MyContext } from "../Context/MyProvider";
import { useSnackbar } from "notistack";
import axios from "axios";
import Btn_loader from "../Component/pages/Btn_loader";
import Razorpay from "./Razorpay";
import AllPayment from "./AllPayment";
import secureLocalStorage from "react-secure-storage";

const Payment = ({ Amount, data, type }) => {

    const { BaseUrl, setPaymentLoading, paymentLoading } = useContext(MyContext);
    const { enqueueSnackbar } = useSnackbar();

    const [apiLoading, setApiLoading] = useState(false);
    const [selectPayment, setSelectPayment] = useState("");
    const [paymentList, setPaymentList] = useState([]);
    const [attributes, setAttributes] = useState("");
    const [isTrue, setIsTrue] = useState(false);

    const PaymentRef = useRef(false);

    useEffect(() => {
        handleGetPaymentList();
    }, []);

    const handleGetPaymentList = () => {
        if (PaymentRef.current) return;
        PaymentRef.current = true;
        setApiLoading(true);
        axios.get(`${BaseUrl}/coustomer/services/payment_list`)
            .then((res) => {
                setPaymentList(res?.data?.Payment);
                setApiLoading(false);
            })
            .catch((error) => {
                console.error("payment_list", error);
            });
    }

    const handleContinue = () => {
        if (!selectPayment) {
            enqueueSnackbar('Please select payment method !!', { variant: 'error' });
            return;
        }

        if (data) {
            const apiBody = {
                ...data,
                type: selectPayment
            }
            secureLocalStorage.setItem("package", JSON.stringify(apiBody));
        }

        secureLocalStorage.setItem("Plantype", type);
        setPaymentLoading(true);
        setIsTrue(true);
    }

    return (
        <div>
            <h1 className='font-bold text-[17px] mb-2'>Select Payment method</h1>

            {apiLoading
                ? <div className="h-[300px]">
                    <Btn_loader CustomeStyle={"bg-black"} />
                </div>
                : <div className="max-h-[400px] scroll_container">
                    {paymentList.map((item, index) => {
                        const IsSelected = item.payment_type === selectPayment;
                        return <div key={index} onClick={() => { !paymentLoading && setSelectPayment(item.payment_type); setAttributes(item.secret_id) }} className={`w-full mt-3 border p-[10px] rounded-[10px] cursor-pointer ${IsSelected ? "border-black" : "border-gray-300"}`}>
                            <div className="w-full flex items-center gap-[10px]">
                                <div className="flex items-center gap-[20px]">
                                    <div className="max-w-[60px] min-w-[60px] h-[60px] border-[1px] rounded-[10px] overflow-hidden border-gray-300">
                                        <img src={BaseUrl + item.payment_image} className="w-full h-full " alt="payment_image" />
                                    </div>
                                    <div className="leading-6">
                                        <h1 className='font-bold'>{item.payment_name}</h1>
                                        <p className='leading-4 font-medium text-[14px] text-gray-500 line-clamp-2'>{item.description}</p>
                                    </div>
                                </div>
                                <div className="w-[20px]">
                                    <div className={`w-[18px] h-[18px] duration-[.5s] border-[2px] ${IsSelected ? "border-[--bgcolor]" : "border-gray-300"} rounded-full p-[2px]`}>
                                        <div className={`w-full h-full duration-[.5s] rounded-full ${IsSelected ? "bg-black" : "bg-transparent"}`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}
                </div>}

            <button onClick={handleContinue} className="w-full bg-black text-white h-[45px] rounded-lg font-bold hover:shadow-lg transition duration-300 mt-5">
                {paymentLoading
                    ? <Btn_loader CustomeStyle={"bg-white"} />
                    : "Continue"}
            </button>

            {(selectPayment === "1" && isTrue) && <Razorpay Amount={Amount} attributes={attributes} />}
            {(selectPayment === "2" && isTrue) && <AllPayment Amount={Amount} Url={"/coustomer/payment/strip-payment"} setIsTrue={setIsTrue} />}

        </div>
    )
}

export default Payment